import React from 'react';
import config from '../../constant/config';
import auth from '../../lib/auth';
import checkStatus from '../common/checkStatus';
import ModuleHeader from '../common/ModuleHeader';
import CreateModule from '../common/CreateModuleContainer';
import './EditModule.css';

class EditModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      module: [],
      hubName: '',
      categoryDescription: '',
      actionButton: null,
      isAdmin: true,
      moduleNotFound: false,
      filtersApproved: false,
      hubId: ''
    };
  }

  async componentWillMount() {
    if (!this.props.user) {
      this.props.history.push('/');
    } else {
      await this.getModule();
      await this.getHub();
    }
  }

  async getModule() {
    const { moduleId } = this.props.match.params;
    try {
      const res = await fetch(`${config.apiURL}/module/${moduleId}`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      });
      if (res.status === 200) {
        const module = await res.json();
        const isAdmin = await auth.isAuthenticatedHubAdmin(module.hub.id);
        const actionButton = this.renderActionButton(isAdmin);
        this.setState({
          module,
          hubName: module.hub.name,
          categoryDescription: module.category.description,
          actionButton,
          isAdmin,
          hubId: module.hub.id
        });
      }
      if (res.status === 404) {
        this.setState({ moduleNotFound: true });
      }
    } catch (err) {
      console.log(err);
    }
  }
  
  async getHub() {
    try {
      const res = await fetch(`${config.apiURL}/hub/${this.state.hubId}/`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      });
      console.log(res);
      if (res.status === 200) {
        const hub = await res.json();
        console.log(res);
        this.setState({ filtersApproved: hub.active_filter });
      }
    } catch (err) {
      console.log('Error found in editing a module: HubId not found', err);
    }
  }

  renderActionButton() {
    return;
  }

  render() {
    if (this.state.moduleNotFound) {
      return (
        <div>
          <center>Module not found</center>
        </div>
      );
    } else {
      return (
        <div className="edit-module">
          <ModuleHeader
            mod={this.state.module}
            hubName={this.state.hubName}
            categoryDescription={this.state.categoryDescription}
            loggedIn={this.props.user}
            actionButton={this.state.actionButton}
          />
          {this.state.isAdmin ? (
            <CreateModule
              edit
              module={this.state.module}
              moduleId={this.props.match.params.moduleId}
              hubId={this.state.module.hubId}
              user={this.props.user}
              approved
              filtersApproved={this.state.filtersApproved}
            />
          ) : (
            <div>
              <center>
                <p>You do not have access to this page</p>
              </center>
            </div>
          )}
        </div>
      );
    }
  }
}

export default checkStatus(EditModule);
